import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './HomeScreen.module.css'; // Import the CSS module

const HomeScreen = () => {
    const navigate = useNavigate();

    const handleSignUp = () => {
        navigate('/createuser');
    };

    const handleLogin = () => {
        navigate('/login');
    };

    return (
        <div className={styles['home-screen']}>
            <h1 className={styles.title}>Paddr Tracker</h1>
            <p className={styles.tagline}>beer.</p>
            <div className={styles['button-container']}>
                <button className={`${styles.btn} ${styles['sign-up-btn']}`} onClick={handleSignUp}>
                    Sign Up
                </button>
                <button className={`${styles.btn} ${styles['login-btn']}`} onClick={handleLogin}>
                    Log In
                </button>
            </div>
        </div>
    );
};

export default HomeScreen;
